var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            {
              staticClass: "pt-0 pb-2 text-body-2 text--secondary",
              attrs: { cols: "10" }
            },
            [_vm._v(" " + _vm._s(_vm.title) + " ")]
          ),
          _c(
            "v-col",
            {
              staticClass: "pt-0 pb-2 text-right text-body-2",
              attrs: { cols: "2" }
            },
            [
              _vm.info
                ? _c(
                    "v-tooltip",
                    {
                      attrs: { left: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function(ref) {
                              var on = ref.on
                              var attrs = ref.attrs
                              return [
                                _c(
                                  "v-icon",
                                  _vm._g(
                                    _vm._b(
                                      {
                                        staticClass:
                                          "text-body-2 text--secondary"
                                      },
                                      "v-icon",
                                      attrs,
                                      false
                                    ),
                                    on
                                  ),
                                  [_vm._v("mdi-alert-circle")]
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        1033052631
                      )
                    },
                    [_c("span", [_vm._v(_vm._s(_vm.info))])]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { staticClass: "pt-0 pb-0", attrs: { cols: "12" } },
            [_vm._t("default")],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }